// src/components/CitationSearch.jsx
import React, { useEffect, useState } from "react";
import LoginForm from "./views/auth/LoginForm";
import Citation from "./views/citations/Citation";
import { useAuth } from "./contexts/AuthContext";

const App = () => {
    const { apiKey } = useAuth();

    if (!apiKey) {
        return (
            <LoginForm />
        );
    }


    return <Citation />;
};

export default App;
